import { z } from 'zod';

/**
 * Full specification of an OpgaveKomplekset component, including all tasks
 * data, transformed into a desired format.
 */

/**
 * Basic descriptor of an OpgaveKomplekset task, including general settings
 * etc.
 *
 * NB: UnprocessedOpgaveKompleksetComponentData will not contain actual tasks,
 * these will first be available after resolving descriptors, which must be done
 * in a post-processing step.
 */

const settingsSchema = z.object({
  allowedAttempts: z.number().default(1),
  progression: z.enum(["fixed", "conditional", "free"]).default("fixed"),
  taskOrder: z.enum(["fixed", "random"]).default("fixed"),
  speechSynthesis: z.object({
    languages: z.array(z.string().transform(val => {
      switch (val) {
        case "en-gb":
          return "English";
        case "de-de":
          return "German";
        case "fr-fr":
          return "French";
        case "es-es":
          return "Spanish";
        case "da-dk":
        default:
          return "Danish";
      }
    })).default(["Danish"])
  }).default({
    languages: ["Danish"]
  })
});
const taskDescriptorSchema = z.object({
  type: z.literal("task"),
  id: z.string(),
  title: z.string()
});
const folderSchema = z.object({
  type: z.literal("folder"),
  id: z.string(),
  title: z.string(),
  tasks: z.number()
});
const opgavekompleksetDataSchema = z.object({
  course: z.array(z.union([z.discriminatedUnion("type", [taskDescriptorSchema, folderSchema]), z.array(taskDescriptorSchema)])),
  feedback: z.object({
    frequency: z.object({
      validation: z.boolean(),
      report: z.boolean()
    })
  }),
  settings: settingsSchema,
  layout: z.object({
    type: z.enum(["young", "default"]),
    colors: z.object({
      primary: z.string().nullable().default(null)
    }).nullable()
  }).nullable().default(null),
  helpTexts: z.record(z.string(),
  // taskId,
  z.array(z.object({
    attempt: z.number(),
    text: z.string()
  }))),
  progressConditions: z.record(z.string(), z.object({
    conditions: z.array(z.object({
      answer: z.string().nullable().default(null),
      goTo: z.union([z.literal("next"), z.literal("result"), z.string()]).nullable().default(null)
    })).default([]),
    otherwiseGoTo: z.union([z.object({
      onCorrect: z.union([z.literal("next"), z.literal("result"), z.string()]).nullable().default(null),
      onPartial: z.union([z.literal("next"), z.literal("result"), z.string()]).nullable().default(null),
      onIncorrect: z.union([z.literal("next"), z.literal("result"), z.string()]).nullable().default(null)
    }).default({
      onCorrect: null,
      onIncorrect: null,
      onPartial: null
    }),
    // otherwiseGoTo was extended to support both onCorrect and
    // onIncorrect by ADO #124215
    z.union([z.literal("next"), z.literal("result"), z.string()]).nullable().default(null).transform(val => ({
      onCorrect: val,
      onPartial: val,
      onIncorrect: val
    }))])
  })).default({})
});

export { opgavekompleksetDataSchema };
//# sourceMappingURL=_component-data.js.map
